// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__xkSON","requiredAsterisk":"Info_requiredAsterisk__2yyA6"};